import { render, staticRenderFns } from "./modalProcedimientoPorPrograma.vue?vue&type=template&id=c86f946e&scoped=true&"
import script from "./modalProcedimientoPorPrograma.vue?vue&type=script&lang=js&"
export * from "./modalProcedimientoPorPrograma.vue?vue&type=script&lang=js&"
import style0 from "./modalProcedimientoPorPrograma.vue?vue&type=style&index=0&id=c86f946e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c86f946e",
  null
  
)

export default component.exports